export default __webpack_public_path__ + "static/media/thinking.fc98a4e2.png";